import { createMutation, createQuery } from 'react-query-kit';

import * as Types from '../api/programme/types.api';
import * as API from '../api/programme/index.api';
import { queryClient } from 'src';
import { enqueueSnackbar } from 'notistack';

//
//

const key = 'programmes';

const invalidateQueryFootprint = (code: string) => {
  queryClient.invalidateQueries({
    queryKey: useQueryProgrammesList.getKey({ merchantCode: code }),
  });
};

//

export const useQueryProgrammesList = createQuery<
  Types.GetProgrammesResponse,
  Types.GetProgrammesQuery
>({
  queryKey: [key],
  fetcher: (params) => API.getProgrammesListAPI(params),
});

//

export const useMutationProgrammeCreate = createMutation<any, Types.CreateProgrammePayload>({
  mutationKey: [key, 'create'],
  mutationFn: (params) => API.createProgrammeAPI(params),
  onSuccess: (_, variables) => invalidateQueryFootprint(variables.merchantCode),
});

//

export const useMutationProgrammeUpdate = createMutation<any, Types.UpdateProgrammePayload>({
  mutationKey: [key, 'update'],
  mutationFn: (params) => API.updateProgrammeAPI(params),
  onSuccess: (_, variables) => {
    invalidateQueryFootprint(variables.merchantCode);
    enqueueSnackbar('Programme successfully updated', { variant: 'success' });
  },
});
